module.exports = __webpack_public_path__ + "static/media/object-farm-01.bf20a5ab.svg";